<template>
    <div>
        <!-- Modal-->
        <div class="modal fade" id="createAccountModal" data-backdrop="static" tabindex="-1" role="dialog"
             aria-labelledby="staticBackdrop" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Create Account</h5>
                        <button ref="closeModalButton" type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i aria-hidden="true" class="ki ki-close"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="newAccount !== null">
                            <table class="table">
                                <tr>
                                    <td class="font-weight-bold">Host:</td>
                                    <td>{{ newAccount.host }}</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bold">Username:</td>
                                    <td>{{ newAccount.username }}</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bold">Password:</td>
                                    <td>{{ newAccount.password }}</td>
                                </tr>
                            </table>
                        </div>
                        <div v-else>
                            <label>Username</label>
                            <input class="form-control" type="text" placeholder="Username" v-model="newUsername"
                                   @keyup="stripUnwantedChars">
                            <div v-if="creationError" class="my-3 text-danger">
                                {{ creationError }}
                            </div>
                            <button v-show="!creating" class="btn btn-primary mt-3" @click="createAccount">
                                <i class="fas fa-save"/> Create
                            </button>
                        </div>
                        <div v-show="creating" class="spinner spinner-track spinner-primary" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Button -->
        <div class="mb-2">
            <button
                class="btn btn-fixed-height btn-bg-white btn-text-dark-50 btn-icon-primary btn-hover-primary font-weight-bolder font-size-sm px-5 my-1"
                data-toggle="modal" data-target="#createAccountModal"
                @click="resetModal">
                <i class="fas fa-plus"/>&nbsp;Create Account
            </button>
        </div>
    </div>
</template>

<script>
import {PermissionsMixin} from "@js/permissions";

export default {
    mixins: [PermissionsMixin],

    data() {
        return {
            newUsername: '',
            creationError: '',
            creating: false,
            newAccount: null,
        }
    },

    methods: {
        stripUnwantedChars() {
            this.newUsername = this.newUsername.replace(' ', '_').replace(/[^a-z0-9_]/i, '').toLowerCase();
        },

        resetModal() {
            this.newUsername = '';
            this.newAccount = null;
            this.$refs.closeModalButton.click()
        },

        createAccount() {
            this.creating = true;
            this.$inertia.post(this.$route('ftp.accounts.create'), {username: this.newUsername});
            this.resetModal();
        },
    }
}
</script>
